export default __webpack_public_path__ + "static/media/06.d7b0e7be.png";